export default "__VITE_ASSET__CU60wtHL__"